import * as React from "react";
const SvgFiRrUserLock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-lock_svg__a)">
      <path
        fill="#062147"
        d="M22 14.537V13c0-2.206-1.794-4-4-4s-4 1.794-4 4v1.537A4 4 0 0 0 12 18v2c0 2.206 1.794 4 4 4h4c2.206 0 4-1.794 4-4v-2c0-1.477-.805-2.77-2-3.463M16 13c0-1.103.897-2 2-2s2 .897 2 2v1h-4zm6 7c0 1.103-.897 2-2 2h-4c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2zm-2.5-1a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 19.5 19M8 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6M8 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m1.99 13.211a1 1 0 0 1-1.131.85A6.006 6.006 0 0 0 2 22v1a1 1 0 0 1-2 0v-1c0-4.411 3.589-8 8-8 .379 0 .763.027 1.141.081.547.078.927.584.85 1.131z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-lock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserLock;
